import React, { useContext } from 'react';
import { oneOf, string } from 'prop-types';
import classNames from 'classnames/bind';
import { Button, Loader, Placeholder } from '@thd-olt-component-react/core-ui';
import { StorePodContext } from '../../StorePod.context';
import styles from './store-pod-link.module.scss';

const cx = classNames.bind(styles);

export const StorePodLink = ({ className, type, visualStyle }) => {
  const { isDesignStore, loading, store } = useContext(StorePodContext);

  const { address, storeDetailsPageLink, storeId } = store;
  const { city, postalCode, state, street } = address || {};
  const addressFormatted = `${street}, ${city}, ${state} ${postalCode}`;

  const linkMap = {
    directions: {
      href: `https://www.bing.com/mapspreview?where1=${addressFormatted}&amp;sty=c`,
      text: 'Directions'
    },
    localAd: {
      href: `/c/localad?StoreRef=${storeId}`,
      text: 'Local Ad'
    },
    rentals: {
      href: `${storeDetailsPageLink}/rentals`,
      text: 'Available Rentals',
    },
    services: {
      href: `${storeDetailsPageLink}/services`,
      text: 'Available Services',
    },
    store: {
      href: storeDetailsPageLink,
      text: isDesignStore ? 'Learn More' : 'Store Details'
    }
  };

  const { href, text } = linkMap[type];

  const handleButtonClick = () => {
    window.location.href = href;
  };

  if (loading) {
    return (
      <div className={cx(className, 'store-pod-link')}>
        <Placeholder
          width={visualStyle === 'button' ? '120px' : '80px'}
          height={visualStyle === 'button' ? '40px' : '30px'}
          type={visualStyle === 'button' ? 'rect' : 'text'}
        />
      </div>
    );
  }

  const linkClasses = cx(className, 'store-pod-link', {
    'store-pod-link--fit-content': visualStyle === 'link'
  });

  const textClasses = cx({
    'store-pod-link__text': visualStyle === 'button'
  });

  return (
    <div className={linkClasses}>
      <Button
        link={visualStyle === 'link'}
        onClick={handleButtonClick}
        tag="a"
        data-testid="store-pod-link__button"
        href={href}
      >
        <span className={textClasses}>{text}</span>
      </Button>
    </div>
  );
};

StorePodLink.propTypes = {
  className: string,
  type: oneOf(['directions', 'localAd', 'store', 'services', 'rentals']),
  visualStyle: oneOf(['button', 'link'])
};

StorePodLink.defaultProps = {
  className: null,
  type: 'store',
  visualStyle: 'link'
};

StorePodLink.displayName = 'StorePodLink';
